import { CommonModule } from "@angular/common";
import {  Component, EventEmitter, Input, Output } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
@Component({
  selector: "app-frame-67",
  templateUrl: "./frame-67.component.html",
  styleUrls: ["./frame-67.component.scss"],
  imports: [CommonModule,MatTooltipModule],
  standalone: true,
})
export class Frame67Component {
  @Input() isFullScreen: boolean = false;
  @Input() isNewPage: boolean = false;
   dropdownOpen = false;

  @Input() assetReviewStoreDetails : any;
  @Output() expandRequested = new EventEmitter<void>();
  @Output() assetReviewClose = new EventEmitter<void>();
  @Output() openInNewPageRequested = new EventEmitter<void>();
  isExpandedView = false;
  expandPanel() {
  console.log("🚀 ~ Frame67Component ~ expandPanel ~ expandPanel:")
  this.isExpandedView = !this.isExpandedView;
  this.expandRequested.emit();
  }

  assetReviewClosehandle() {
  this.assetReviewClose.emit();
  }

  openInNewPage() {
    this.openInNewPageRequested.emit();
  }

  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;

    
  }

  closeDropdown(): void {
    this.dropdownOpen = false;
  }

  download(type: 'pdf' | 'excel' | 'csv'): void {
    this.dropdownOpen = false;
    // TODO: Hook into your actual download logic here
    console.log(`Downloading as ${type.toUpperCase()}`);
  }
}
